/**
 * Created by Ning Jiang on 10/5/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {TombstoneMultiplierController} from "../../multiplier/TombstoneMultiplierController";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneWildSymbol} from "../../symbols/TombstoneWildSymbol";

export class WildAttentionController extends ReelStopPresentationController {

    private _overlayWilds:boolean[][];
    private _overlayWildsBeforeSpin:boolean[][];

    constructor(index:number) {
        super(index, "WildAttention");
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._overlayWilds = data.overlayWilds!;
        this._overlayWildsBeforeSpin = data.overlayWildsBeforeSpin;
    }

    public onReelBounce(data:IReelStoppedData):void {
        // sticky reel from last spin.
        if(this._overlayWildsBeforeSpin[data.reelId][0]) {
            return;
        }

        // no wild on reel
        if(!this._overlayWilds[data.reelId][0]) {
            return;
        }

        let wild:TombstoneWildSymbol;
        for(let i:number = 1; i < 4; i++) {
            if(this._gameData!.reels[data.reelId][i].indexOf("W") > -1) {
                wild = <TombstoneWildSymbol>Reels.getSymbol(data.reelId, i - 1);
                if(wild == null) {
                    debugger;
                    throw new Error(`WildAttentionController.onReelBounce(): Cannot find Wild symbol at reel ${data.reelId}`);
                }

                wild.updateMultiplier(1, true);
                break;
            }
        }

        // Update multiplier #36
        EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.ADD_MULTIPLIER));
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }
}